import { Box, Container, Typography } from '@material-ui/core';
import { CONTRATO_ETAPAS_PARAMS_URL, URL_ENTE_DESCENTRALIZADO, VersaoContratoEnum } from '../../../../models/contratos';
import CoopIcon from 'assets/icons/CoopIcon';
import FolderIcon from 'assets/icons/FolderIcon';
import InfoIconTwo from 'assets/icons/InfoIconTwo';
import { Col } from 'components/Col';
import { CustomBreadCrumbsContratos } from 'components/CustomBreadCrumbsContratos';
import { CustomButton } from 'components/CustomButton';
import { Row } from 'components/Row';
import { contratosRoute } from 'library/Routes';
import { STEP_DADOS_CONTRATADO, STEP_DADOS_COOPERATIVA, STEP_DOCUMENTOS, Steps } from 'models/contratos';
import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { RootState } from 'store';
import { clearContratoAssessorEditing, loadContratoAssessor } from 'store/modules/ContratosFluxoDescentralizado/Assessores/AssessoresActions';
import { clearContratoEntePrivadoEditing, loadContratoEntePrivado } from 'store/modules/ContratosFluxoDescentralizado/EntePrivado/EntePrivadoActions';
import { clearContratoEntePublicoEditing, loadContratoEntePublico } from 'store/modules/ContratosFluxoDescentralizado/EntePublico/EntePublicoActions';
import { openModal } from 'store/modules/ModalActions';
import { ContratoStep } from '../../components/ContratoStep/ContratoStep';
import ModalConfirm from '../../components/ModalConfirm';
import { CreateRouteParams, EditRouteParams } from './__types';
import { ContratoAssessorDescentralizado } from './Assessor';
import { DocumentoAssessorDescentralizado } from './Assessor/Documentos';
import FluxoGenericDadosCooperativa from './DadosDaCooperativa';
import { ContratoEntePrivadoDescentralizado } from './EntePrivado';
import { DocumentoEntePrivadoDescentralizado } from './EntePrivado/Documento';
import { ContratoEntePublicoDescentralizado } from './EntePublico';
import { DocumentoEntePublicoDescentralizado } from './EntePublico/Documentos';
import useContratoDescentralizadoStep from './hooks/useContratoDescentralizadoStep';
import useValidations from './hooks/useValidations';
import './index.scss';

export const FluxoContratosDescentralizados = () => {
    const history = useHistory();
    const languageValues = useSelector((state: RootState) => state.languages.languageValues);
    const { avancaContratoStep, navegaEntreSteps } = useContratoDescentralizadoStep();
    const currentStepContrato = useSelector((state: RootState) => state.allContratos.currentContratoStep
    );
    const contratosReducer = useSelector(
        (state: RootState) => state.allContratos
    );
    const { habilitaBotaoAvancaStep } = useValidations();
    const params = useParams<CreateRouteParams & EditRouteParams>();
    const location = useLocation();
    const dispatch = useDispatch();

    const fluxoAssessor = location.pathname.includes(URL_ENTE_DESCENTRALIZADO.ASSESSOR);
    const fluxoEntePublico = location.pathname.includes(URL_ENTE_DESCENTRALIZADO.ENTE_PUBLICO);
    const fluxoEntePrivado = location.pathname.includes(URL_ENTE_DESCENTRALIZADO.ENTE_PRIVADO);

    const fluxoCadastroRoute = location.pathname.includes(CONTRATO_ETAPAS_PARAMS_URL.CADASTRO)
    const fluxoEdicaoRoute = location.pathname.includes(CONTRATO_ETAPAS_PARAMS_URL.EDICAO)

    const items = useMemo(() => [
        {
            id: STEP_DADOS_COOPERATIVA,
            icon: <CoopIcon />,
            label: languageValues.dadosCooperativa,
            onClick: () => navegaEntreSteps(STEP_DADOS_COOPERATIVA)
        },
        {
            id: STEP_DADOS_CONTRATADO,
            icon: <InfoIconTwo />,
            label: languageValues.DadosContratadoOuContratante,
            onClick: () => navegaEntreSteps(STEP_DADOS_CONTRATADO)
        },
        {
            id: STEP_DOCUMENTOS,
            icon: <FolderIcon />,
            label: languageValues.documentos,
            onClick: () => navegaEntreSteps(STEP_DOCUMENTOS)
        },
    ], [languageValues, navegaEntreSteps]);

    useEffect(() => {
        const currentUrl = window.location.pathname;
        if (!currentUrl.includes('/cadastro-de-contratos') && !currentUrl.includes('/edicao-de-contratos')) {
            history.push(contratosRoute.path);
        }
    }, [languageValues, history]);

    const formComponents = [
        {
            id: STEP_DADOS_CONTRATADO,
            components: [
                {
                    url: URL_ENTE_DESCENTRALIZADO.ENTE_PUBLICO,
                    component: ContratoEntePublicoDescentralizado,
                },
                {
                    url: URL_ENTE_DESCENTRALIZADO.ENTE_PRIVADO,
                    component: ContratoEntePrivadoDescentralizado,
                },
                {
                    url: URL_ENTE_DESCENTRALIZADO.ASSESSOR,
                    component: ContratoAssessorDescentralizado,
                },
            ],
        },
        {
            id: STEP_DOCUMENTOS,
            components: [
                {
                    url: URL_ENTE_DESCENTRALIZADO.ENTE_PUBLICO,
                    component: DocumentoEntePublicoDescentralizado,
                },
                {
                    url: URL_ENTE_DESCENTRALIZADO.ENTE_PRIVADO,
                    component: DocumentoEntePrivadoDescentralizado,
                },
                {
                    url: URL_ENTE_DESCENTRALIZADO.ASSESSOR,
                    component: DocumentoAssessorDescentralizado,
                },
            ],
        },
    ];

    const renderizaFormularios = useCallback((id: number) => {
        if (id === STEP_DADOS_COOPERATIVA) {
            return <FluxoGenericDadosCooperativa />;
        }
        const formComponent = formComponents.find((component) => component.id === id);
        if (!formComponent) return null;
        const currentUrl = window.location.pathname;
        const formComponentItem = formComponent.components.find((component) => currentUrl.includes(component.url));
        return formComponentItem ? <formComponentItem.component /> : null;
        // eslint-disable-next-line
    }, []);

    const fluxoEdicaoContrato = useCallback(() => {
        const adendos = contratosReducer.adendoObject.adendos;
        const adendoContrato = adendos.find(adendo => adendo.versaoContrato === VersaoContratoEnum.CONTRATO);
        if (adendoContrato) {
            switch (true) {
                case (fluxoAssessor):
                    dispatch(loadContratoAssessor(Number(params.id), VersaoContratoEnum.CONTRATO));
                    break
                case (fluxoEntePublico):
                    dispatch(loadContratoEntePublico(Number(params.id), VersaoContratoEnum.CONTRATO));
                    break;
                case (fluxoEntePrivado):
                    dispatch(loadContratoEntePrivado(Number(params.id), VersaoContratoEnum.CONTRATO));
                    break;
            }
            navegaEntreSteps(currentStepContrato - 1);
            return true;
        }
        return false;
    }, [contratosReducer.adendoObject.adendos,
        currentStepContrato,
        dispatch,
        fluxoAssessor,
        fluxoEntePrivado,
        fluxoEntePublico,
        navegaEntreSteps,
    params.id
    ])

    const fluxoCadastroContrato = useCallback(() => {
        dispatch(openModal(ModalConfirm, {
            title: languageValues.aviso,
            content: languageValues.contratosWarningProgressModalLost,
            confirmLabel: languageValues.sair,
            cancelLabel: languageValues.cancelButton,
            confirmCallback: () => {
                switch (true) {
                    case (fluxoAssessor):
                        dispatch(clearContratoAssessorEditing());
                        break
                    case (fluxoEntePublico):
                        dispatch(clearContratoEntePublicoEditing())
                        break;
                    case (fluxoEntePrivado):
                        dispatch(clearContratoEntePrivadoEditing())
                        break;
                }
                history.push(contratosRoute.path)
            },
            modalKey: 'modalCancell',
            maxWidth: 'sm'
        }));
    }, [dispatch,
        fluxoAssessor,
        fluxoEntePrivado,
        fluxoEntePublico,
        history,
        languageValues.aviso,
        languageValues.cancelButton,
        languageValues.contratosWarningProgressModalLost,
        languageValues.sair])

    const fluxoBotaoRetornar = useCallback(() => {
        if (fluxoCadastroRoute) {
            fluxoCadastroContrato()
        } else if (fluxoEdicaoRoute) {
            fluxoEdicaoContrato()
        }
    }, [fluxoCadastroContrato,
        fluxoCadastroRoute,
        fluxoEdicaoContrato,
        fluxoEdicaoRoute])

    const modalDeConclusao = useCallback(() => {
        dispatch(openModal(ModalConfirm, {
            title: languageValues.concluirCadastro,
            content: languageValues.desejaConcluirEdicaoDosDadosDesseContrato,
            confirmLabel: languageValues.concluir,
            confirmCallback: () => {
                history.push(contratosRoute.path);
            },
            modalKey: 'modalComplete',
            maxWidth: 'sm'
        }));
    }, [dispatch, history, languageValues])

    return (
        <Container maxWidth='lg' style={{ padding: 0 }}>
            <Row>
                <Col cols={[12, 12, 12, 12, 12]}>
                    <CustomBreadCrumbsContratos route={contratosRoute} />
                    <Box className='fluxoContratosDescentralizados__box-contrato-step'>
                        <ContratoStep
                            items={items}
                            renderForm={renderizaFormularios}
                            navigateToStep={navegaEntreSteps}
                        />
                    </Box>
                </Col>
            </Row>
            <Row className='fluxoContratosDescentralizados__row'>
                <Typography className='fluxoContratosDescentralizados__legend'>
                    {languageValues.campoObrigatorio}
                </Typography>
                <Row >
                    {currentStepContrato === Steps.DADOS_CONTRATADO ||
                        currentStepContrato === Steps.DOCUMENTOS ? (
                        <Col cols={[12, 5, 5, 5, 5]}>
                            <CustomButton
                                theme='pufvYellow'
                                className={'fluxoContratosDescentralizados__button-back'}
                                label={languageValues.voltar}
                                onClick={() => fluxoBotaoRetornar()}
                                disabled={false}
                            />
                        </Col>
                    ) : null}
                    {currentStepContrato === Steps.DOCUMENTOS ? (
                        <Col cols={[12, 5, 5, 5, 5]}>
                            <CustomButton
                                theme='pufvYellow'
                                className={'fluxoContratosDescentralizados__button-cadastrar'}
                                label={languageValues.concluir}
                                onClick={() => modalDeConclusao()}
                                disabled={habilitaBotaoAvancaStep()}
                            />
                        </Col>
                    ) :
                        <Col cols={[12, 5, 5, 5, 5]}>
                            <CustomButton
                                theme='pufvYellow'
                                className={'fluxoContratosDescentralizados__button-prosseguir'}
                                label={languageValues.prosseguir}
                                onClick={() => avancaContratoStep()}
                                disabled={habilitaBotaoAvancaStep()}
                            />
                        </Col>
                    }
                </Row>
            </Row>
        </Container>
    );
};